<script>
export default {
    name: 'IconPlay',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-play"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" d="M16 12v40l40-20z" fill-rule="evenodd" />
    </svg>
</template>
